module.exports = __webpack_public_path__ + "static/img/partner_logo_03.6f5f03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner_logo_03.png
// module id = c3ld
// module chunks = 2